import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";
import {
  RedoModal,
  RedoModalButtonProps,
} from "@redotech/arbiter/modal/redo-modal";
import { getViewNameValidationError } from "@redotech/redo-views-common/views";
import { memo, useState } from "react";

export const CreateInventoryViewFolderModal = memo(
  function CreateInventoryViewFolderModal({
    isOpen,
    onClose,
    onSubmit,
    reservedFolderNames,
  }: {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (folderName: string) => Promise<void>;
    reservedFolderNames: Set<string>;
  }) {
    const [folderName, setFolderName] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async () => {
      try {
        setIsSubmitting(true);
        await onSubmit(folderName);
        onClose();
      } finally {
        setIsSubmitting(false);
        setFolderName("");
      }
    };

    const validationError = getViewNameValidationError(folderName);
    const isDuplicate = reservedFolderNames.has(folderName.trim());
    const primaryButton: RedoModalButtonProps = {
      text: "Create",
      onClick: handleSubmit,
      disabled:
        validationError ??
        (isDuplicate ? "A folder with this name already exists" : false),
      size: "sm",
    };

    const secondaryButton: RedoModalButtonProps = {
      text: "Cancel",
      onClick: onClose,
      disabled: isSubmitting,
      pending: false,
      size: "sm",
    };

    return (
      <RedoModal
        isOpen={isOpen}
        modalSize="sm"
        onModalCloseRequested={isSubmitting ? () => {} : onClose}
        primaryButton={primaryButton}
        secondaryButton={secondaryButton}
        title="Create folder"
      >
        <RedoTextInput
          label="Folder name"
          setValue={setFolderName}
          size="sm"
          state={isSubmitting ? "readonly" : "default"}
          value={folderName}
        />
      </RedoModal>
    );
  },
);
